export default __webpack_public_path__ + "static/media/278.c4599348.jpg";